import { render, staticRenderFns } from "./AlarmPlacePage.vue?vue&type=template&id=ae00f22a&scoped=true"
import script from "./AlarmPlacePage.vue?vue&type=script&lang=js"
export * from "./AlarmPlacePage.vue?vue&type=script&lang=js"
import style0 from "./AlarmPlacePage.vue?vue&type=style&index=0&id=ae00f22a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae00f22a",
  null
  
)

export default component.exports